import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../App.scss';

const FooterBar: React.FC = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section id="footer-bar" className="footer-bar py-5 text-white">
      <Container>
        <Row className="mb-4 text-center">
          <Col>
            <h2 className="font-title">
            Učestvujte u kvizu i osvojite <strong>jednu od vrednih nagrada!</strong>
            </h2>
            {/* <h2 className="font-title">
            Premio principale e premi simbolici quotidiani che regalano sorrisi, scintille e gioia!
            </h2> */}
          </Col>
        </Row>
        <button
          className="quiz-button"
          onClick={() => navigate('/prijava')}
        >
          {isMobile ? (
            <span>ZAPOČNI KVIZ</span>
          ) : (
            <>
              <span>ZAPOČNI KVIZ</span>
            </>
          )}
        </button>
      </Container>
    </section>
  );
};

export default FooterBar;
